import auth from './auth';

export default {
  getFocusAreas: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/focus_area.json`);
  },

  getHours: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/hours.json`);
  },

  getDays: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/days.json`);
  },

  getDayOfWeek: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/day_of_week.json`);
  },

  getMonths: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/months.json`);
  },

  getAnswers: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/answers.json`);
  },

  getAgeGroup: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/age_group.json`);
  },

  getEducationLevel: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/education_level.json`);
  },

  getGender: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/gender.json`);
  },

  getMaritalStatus: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/marital_status.json`);
  },

  getLike: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/like.json`);
  },

  getNationalities: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/nationalities.json`);
  },

  getProfessions: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/professions.json`);
  },

  getTransferTo: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/transfer_to.json`);
  },

  getTransactionTypes: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/transaction_types.json`);
  },

  getLandingOptions: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/landing_options.json`);
  },

  getRatings: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/ratings.json`);
  },

  getRatingBy: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/rating_by.json`);
  },

  getMisc: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/misc.json`);
  },

  getVisits: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/visits.json`);
  },

  getInsightSort:  (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/insights_sort.json`);
  },

  getAccess: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/access.json`);
  },

  getActivityTypes: (locale = auth.getLocale(), fromInsights) => {
    const activityTypes = require(`../constants/translations/${locale}/activity_type.json`);

    return activityTypes.filter(({ hideInInsights }) => !fromInsights || !hideInInsights);
  },

  getActivityActions: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/activity_actions.json`);
  },

  getActivityStates: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/activity_states.json`);
  },

  getRelativeTime: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/relative_time.json`);
  },

  getTopCustomers: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/top_customers.json`);
  },

  getBottomCustomers: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/bottom_customers.json`);
  },

  getProductAction: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/product_action.json`);
  },

  getProfileAction: (locale = auth.getLocale()) => {
    return require(`../constants/translations/${locale}/profile_action.json`);
  }
}
